import { ExternalWallFinishes3DSettings } from './ExternalWallFinishes3DSettings';
import { InternalWallFinishes3DSettings } from './InternalWallFinishes3DSettings';
import { RoomDetection2DSettings } from './RoomDetection2DSettings';
import { RoomDetection3DSettings } from './RoomDetection3DSettings';
import { SymbolDetection2DSettings } from './SymbolDetection2DSettings';
import {
  AutoShapeAlgorithmType,
  ElementWithProperties,
  ExternalWallFinishes3DOptions,
  RoomDetection2DOptions,
  SymbolDetection2DOptions,
} from 'src/gql/graphql';

export type AutoShapeAlgorithmOptionsMap = {
  [AutoShapeAlgorithmType.ExternalWallFinishes_3D]: ExternalWallFinishes3DOptions;
  [AutoShapeAlgorithmType.InternalWallFinishes_3D]: ExternalWallFinishes3DOptions;
  [AutoShapeAlgorithmType.RoomDetection_2D]: RoomDetection2DOptions;
  [AutoShapeAlgorithmType.RoomDetection_3D]: RoomDetection2DOptions;
  [AutoShapeAlgorithmType.SymbolDetection_2D]: SymbolDetection2DOptions;
};

export type AlgorithmSettingsProps<T extends AutoShapeAlgorithmType> = {
  value: AutoShapeAlgorithmOptionsMap[T];
  onChange: (value: AutoShapeAlgorithmOptionsMap[T]) => void;
  onValidityChange: (isValid: boolean) => void;
};

export const algorithmSettingsRegistry = {
  [AutoShapeAlgorithmType.ExternalWallFinishes_3D]:
    ExternalWallFinishes3DSettings,
  [AutoShapeAlgorithmType.InternalWallFinishes_3D]:
    InternalWallFinishes3DSettings,
  [AutoShapeAlgorithmType.RoomDetection_2D]: RoomDetection2DSettings,
  [AutoShapeAlgorithmType.RoomDetection_3D]: RoomDetection3DSettings,
  [AutoShapeAlgorithmType.SymbolDetection_2D]: SymbolDetection2DSettings,
} as {
  [K in AutoShapeAlgorithmType]: React.ComponentType<AlgorithmSettingsProps<K>>;
};

// Helper to get default values for each algorithm
export const getDefaultAlgorithmOptions = <T extends AutoShapeAlgorithmType>(
  algorithmType: T,
  modelId: string,
  globalOffset: { x: number; y: number; z: number },
  elements: ElementWithProperties[],
  sheetId: string,
  pageNumber: number,
  templateRect: { x: number; y: number; width: number; height: number },
  sensitivity: number
) => {
  switch (algorithmType) {
    case AutoShapeAlgorithmType.ExternalWallFinishes_3D:
      return {
        modelId,
        globalOffset,
        elements,
      } as ExternalWallFinishes3DOptions;
    case AutoShapeAlgorithmType.RoomDetection_2D:
      return { pageScales: [] } as RoomDetection2DOptions;
    case AutoShapeAlgorithmType.SymbolDetection_2D:
      return {
        sheetId,
        pageNumber,
        templates: [],
        sensitivity,
      } as SymbolDetection2DOptions;
    default:
      throw new Error(
        `No default options defined for algorithm ${algorithmType}`
      );
  }
};
